import React from 'react';
import { Section } from './ui/Section';
import { User, CheckCircle2, ArrowDown } from 'lucide-react';
import { motion } from 'framer-motion';
export default function ForWhomSection() {
  const points = ['Te acuestas cansado y tu mente se acelera', 'Te da miedo no rendir mañana', 'Ya probaste cosas sueltas y quieres un sistema práctico', 'Quieres algo claro, sin humo, sin misticismo'];
  return <Section className="bg-brand-cream-dark" data-id="element-140">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-141">
        <div className="order-2 md:order-1" data-id="element-142">
          <motion.div whileHover={{
          scale: 1.02
        }} className="bg-brand-navy p-8 rounded-xl border-l-4 border-brand-indigo shadow-lg relative overflow-hidden" data-id="element-143">
            <div className="relative z-10" data-id="element-144">
              <User className="text-brand-indigo mb-4" size={40} data-id="element-145" />
              <p className="font-heading text-2xl md:text-3xl text-slate-200 italic leading-relaxed tracking-wide" data-id="element-146">
                «Estoy destruido… y aun así mi cabeza no se apaga.»
              </p>
            </div>
          </motion.div>
          <p className="mt-8 text-xl text-slate-500 text-center md:text-left" data-id="element-147">
            Porque cuando no duermes, no falla «el sueño». <br data-id="element-148" />
            <span className="text-slate-200 font-bold" data-id="element-149">
              Falla tu sensación de control.
            </span>
          </p>
        </div>

        <div className="order-1 md:order-2" data-id="element-150">
          <h2 className="font-heading text-4xl text-white mb-8 uppercase tracking-wide" data-id="element-151">
            ¿Esto es para ti?
          </h2>
          <ul className="space-y-6" data-id="element-152">
            {points.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.15
          }} className="flex items-start group" data-id="element-153">
                <motion.div initial={{
              scale: 0,
              opacity: 0
            }} whileInView={{
              scale: 1,
              opacity: 1
            }} transition={{
              delay: index * 0.15 + 0.2,
              type: 'spring'
            }} data-id="element-154">
                  <CheckCircle2 className="flex-shrink-0 w-6 h-6 mt-1 text-brand-indigo mr-4 group-hover:text-brand-amber transition-colors" data-id="element-155" />
                </motion.div>
                <span className="text-xl text-slate-400 group-hover:text-slate-200 transition-colors" data-id="element-156">
                  {point}
                </span>
              </motion.li>)}
          </ul>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          delay: 1
        }} className="mt-8 flex items-center gap-2 text-brand-indigo text-sm font-medium" data-id="element-157">
            <span data-id="element-158">Si te identificas, sigue leyendo</span>
            <ArrowDown size={16} className="animate-bounce" data-id="element-159" />
          </motion.div>
        </div>
      </div>
    </Section>;
}